/*******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

import {
  isArr,
  isFn
} from './highcharts-editor';

export function isMap(data) {
  return (
    data.constructor === 'Map' ||
    (data.settings &&
      !isFn(data.settings.constructor) &&
      (isArr(data.settings.constructor)
        ? data.settings.constructor
        : [data.settings.constructor]
      ).some(function (constr) {
        return constr === 'Map';
      }))
  );
}

export function isMapBubble(data, index) {
  return (
    data.options &&
    data.options.series &&
    data.options.series[index] &&
    data.options.series[index].type === 'mapbubble'
  );
}

export function isMapPoint(data, index) {
  return (
    data.options &&
    data.options.series &&
    data.options.series[index] &&
    data.options.series[index].type === 'mappoint'
  );
}

export function isPatternFill(data, index) {
  return (
    data.settings &&
    data.settings.dataProvider &&
    data.settings.dataProvider.seriesMapping &&
    Object.keys(data.settings.dataProvider.seriesMapping[index]).some(
      (key) => {
        return key === 'color.pattern.image';
      }
    )
  );
}

export function getSeriesType(data, index, aggregatedOptions) {
  // Change this in future, data should handle 99% of cases but have had to use aggregatedoptions due to users setting chart type through custom code
  // Looks messy using both atm
  if (isMap(data)) {
    if (
      data.config &&
      data.config.series &&
      data.config.series[index] &&
      data.config.series[index].type
    )
      return data.config.series[index].type;
    else if (data.config && data.config.chart && data.config.chart.type)
      return data.config.chart.type;
    else if (
      data.options &&
      data.options.series &&
      data.options.series[index] &&
      data.options.series[index].type
    )
      return data.options.series[index].type;
    else if (data.type) return data.type;
    else if (isMapBubble(data, index)) return 'mapbubble';
    else if (isMapPoint(data, index)) return 'mappoint';
    else if (isPatternFill(data, index)) return 'patternfill';
    // Find out if theres a better way for this one
    else return 'map';
  } else {
    if (data.config) return data.config.chart.type;
    else {
      if (
        data.options?.series &&
        data.options.series[index] &&
        data.options.series[index].type
      ){
        return data.options.series[index].type;
      }
      if (
        data.template?.series &&
        data.template.series[index] &&
        data.template.series[index].type
      ) {
        return data.template.series[index].type;
      }
      if (data.template && data.template.chart && data.template.chart.type) {
        return data.template.chart.type;
      }
      else if (data.options && data.options.chart && data.options.chart.type)
        return data.options.chart.type;
      else if (
        data.theme &&
        data.theme.options.chart &&
        data.theme.options.chart.type
      )
        return data.theme.options.chart.type;
      else if (
        aggregatedOptions &&
        aggregatedOptions.chart &&
        aggregatedOptions.chart.type
      )
        return aggregatedOptions.chart.type;
      else return 'line';
    }
  }
}